import type { Direction } from "../../direction";
import type { PointsToDirection } from "../../interfaces";
import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";
import { ZOrder } from "../../zOrder.ts";

export class BoxFloor extends Floor implements PointsToDirection {
	static key = "BoxFloor";
	private direction: Direction | null;

	constructor(xy: XY, direction?: Direction) {
		super(xy);
		this.direction = direction ?? null;
	}

	getDirection(): Direction | null {
		return this.direction;
	}

	setDirection(dir: Direction): void {
		this.direction = dir;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), direction: this.direction };
	}

	static deserialize(data: any): BoxFloor {
		const f = new BoxFloor(deserializeXY(data.xy), data.direction ?? undefined);
		f.visualId = data.visualId;
		return f;
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	isHideUnderneath(): boolean {
		return false;
	}
}
